var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import { ReactElementFactory, ReactQuestionFactory, SurveyQuestion } from "survey-react-ui";
import * as React from "react";
var QuestionEditorContentComponent = /** @class */ (function (_super) {
    __extends(QuestionEditorContentComponent, _super);
    function QuestionEditorContentComponent() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    Object.defineProperty(QuestionEditorContentComponent.prototype, "survey", {
        get: function () {
            return this.props.survey;
        },
        enumerable: false,
        configurable: true
    });
    QuestionEditorContentComponent.prototype.createQuestionElement = function (question) {
        return ReactQuestionFactory.Instance.createQuestion(!question.isDefaultRendering || question.isDefaultRendering()
            ? question.getTemplate()
            : question.getComponentName(), {
            question: question,
            isDisplayMode: question.isInputReadOnly,
            creator: this,
        });
    };
    QuestionEditorContentComponent.prototype.questionTitleLocation = function () {
        return this.survey.questionTitleLocation;
    };
    QuestionEditorContentComponent.prototype.questionErrorLocation = function () {
        return this.survey.questionErrorLocation;
    };
    QuestionEditorContentComponent.prototype.renderError = function (key, error, cssClasses) {
        return null;
    };
    QuestionEditorContentComponent.prototype.render = function () {
        var question = this.survey.getAllQuestions()[0];
        return (React.createElement("div", { style: this.props.style },
            React.createElement(SurveyQuestion, { creator: this, element: question })));
    };
    return QuestionEditorContentComponent;
}(React.Component));
export { QuestionEditorContentComponent };
ReactElementFactory.Instance.registerElement("svc-question-editor-content", function (props) {
    return React.createElement(QuestionEditorContentComponent, props);
});
